import React from 'react';
import { Chip } from '@heroui/react';
import { RiShieldUserLine } from '@remixicon/react';

export type RoleType = 'OWNER' | 'ADMIN' | 'EDITOR' | 'VIEWER' | 'MEMBER';

interface RoleChipProps {
  role: RoleType;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'solid' | 'bordered' | 'light' | 'flat' | 'faded' | 'shadow' | 'dot';
  showIcon?: boolean;
}

const ROLE_CONFIG: Record<RoleType, { color: 'danger' | 'warning' | 'primary' | 'success'; label: string }> = {
  OWNER: { color: 'danger', label: 'Owner' },
  ADMIN: { color: 'success', label: 'Admin' },
  EDITOR: { color: 'primary', label: 'Editor' },
  VIEWER: { color: 'warning', label: 'Viewer' },
  MEMBER: { color: 'primary', label: 'Member' }
};

export function RoleChip({ role, size = 'sm', variant = 'flat', showIcon = true }: RoleChipProps) {
  const config = ROLE_CONFIG[role] || { color: 'default', label: role };

  return (
    <Chip
      color={config.color}
      size={size}
      variant={variant}
      startContent={showIcon ? <RiShieldUserLine className="h-3 w-3" /> : undefined}
    >
      <small>{config.label}</small>
    </Chip>
  );
}
